// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"00c3ef77","459":"ba284fe4","853":"ba284fe4"}[chunkId] + ".chunk.css";
};